/*
 * Yarn Park (2026-10-19, improvement plan item 10).
 * A: fills the "Categories" row of the as-you-type box with collections for the search minus filler words
 *    ("chenille yarn" -> "chenille"), which Shopify's own lookup misses because every word must be in the title.
 * B: when the whole search is a known type word ("chunky yarn", "dk", "cotton"), Enter opens that collection
 *    instead of the results page. The word list lives in snippets/yp-search-type-map.liquid.
 */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var fillers = { yarn: 1, yarns: 1, 'for': 1, garn: 1, garne: 1, wolle: 1 };
  var typeMap = {};

  try {
    typeMap = JSON.parse(document.getElementById('yp-search-map').textContent);
  } catch (e) {}

  // Same steps as snippets/yp-search-key.liquid
  function searchKey(terms) {
    var text = String(terms || '').toLowerCase()
      .replace(/yarn art/g, 'yarnart')
      .replace(/t shirt/g, 't-shirt')
      .replace(/tshirt/g, 't-shirt');

    return text.split(/\s+/).map(function (word) {
      return word === 'puffi' ? 'puffy' : word;
    }).filter(function (word) {
      return word !== '' && !fillers[word];
    }).join(' ');
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // A: extra collection lookup for the shortened search
  function fillCategories(row) {
    if (row.getAttribute('data-yp-done')) {
      return;
    }

    row.setAttribute('data-yp-done', '1');

    var extraQuery = row.getAttribute('data-extra-q');
    var known = row.getAttribute('data-known') || ',';

    if (!extraQuery) {
      return;
    }

    var url = root + 'search/suggest.json?q=' + encodeURIComponent(extraQuery) +
      '&resources[type]=collection&resources[limit]=4';

    fetch(url, { credentials: 'same-origin' }).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (!row.isConnected) {
        return;
      }

      var found = (data.resources && data.resources.results && data.resources.results.collections) || [];
      var list = row.querySelector('ul');
      var added = 0;

      found.forEach(function (collection) {
        if (known.indexOf(',' + collection.handle + ',') !== -1) {
          return;
        }

        known += collection.handle + ',';
        list.insertAdjacentHTML('beforeend', '<li><a href="' + escapeHtml(collection.url) +
          '" class="search-bar__result-link">' + escapeHtml(collection.title) + '</a></li>');
        added++;
      });

      if (added > 0) {
        row.hidden = false;

        var emptyState = row.parentNode.querySelector('.search-bar__empty-state');
        if (emptyState) {
          emptyState.hidden = true;
        }
      }
    }).catch(function () {});
  }

  function scan(container) {
    Array.prototype.forEach.call(container.querySelectorAll('[data-yp-cats]'), fillCategories);
  }

  Array.prototype.forEach.call(document.querySelectorAll('.search-bar__results-inner'), function (inner) {
    new MutationObserver(function () {
      scan(inner);
    }).observe(inner, { childList: true });
  });

  // B: Enter on an exact type word opens its collection. Runs before the theme's own submit handler.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var action = form.getAttribute('action') || '';

    if (!/\/search\/?$/.test(action)) {
      return;
    }

    var input = form.querySelector('input[name="q"]');

    if (!input) {
      return;
    }

    var typed = input.value.trim();
    var handle = typeMap[searchKey(typed)];

    if (!handle) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    // yp_search keeps the typed words visible in analytics page URLs, since this skips the search page
    window.location.href = root + 'collections/' + handle + '?yp_search=' + encodeURIComponent(typed);
  }, true);
})();
